import api from "./api";
import merchantToken from "./merchant.token";
import auth from "./auth";
import { camelCase } from "lodash";

const SURVEY_URL = "survey-service/v2/api/merchant/survey";
const RESPONDENT_URL = "survey-service/v2/api/survey/respondent";

export default {
  getSurveyDetails(uuid) {    
    return new Promise((resolve, reject) => {
      api.get(
        `${SURVEY_URL}/details/${uuid}`,
        {
          "X-Merchant-Token": merchantToken.merchantToken()
        }
      )
        .then(response => {
          return resolve(response && response.data ? response.data : null);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  getSurveyDesign(uuid) {
    return new Promise((resolve, reject) => {
      api.get(
        `${SURVEY_URL}/design/details/${uuid}`,
        {
          "X-Merchant-Token": merchantToken.merchantToken()
        }
      )
        .then(response => {
          const { data } = response;
          const design = data.configs.reduce((design, item) => {
            let value = item.value;

            if (value === "0" || value === "1") value = Boolean(Number(value));

            design[camelCase(item.key)] = value;
            return design;
          }, {});

          return resolve(design);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  },
  saveSurveyAnswers({ uuid, questions }) {
    let headers = {
      "X-Merchant-Token": merchantToken.merchantToken()
    };
    const authToken = auth.authToken();

    if (authToken) headers["Authorization"] = authToken;

    return new Promise((resolve, reject) => {
      api.post(
        `${RESPONDENT_URL}/save/${uuid}`,
        { questions },
        headers
      )
        .then(response => {
          return resolve(response);
        })
        .catch((status, error) => {
          reject(status, error);
        });
    });
  }
};
